var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "background rounded-xl"
    }
  }, [_c('v-card-text', [_c('h2', {
    staticClass: "mb-2"
  }, [_vm._v("Kontroller alapinfók:")]), _vm.basicInfo ? _c('div', [_c('ul', _vm._l(_vm.basicInfo, function (part, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(part))]);
  }), 0)]) : _c('div', [_c('p', [_vm._v("Nincs elérhető információ a DS Controller állapotáról.")])]), _c('v-data-table', {
    staticClass: "elevation-1 mt-4 rounded-xl",
    attrs: {
      "headers": _vm.datatable.headers,
      "items": _vm.healthLogs,
      "hide-default-footer": "",
      "dense": ""
    }
  }), _c('v-divider', {
    staticClass: "my-6"
  }), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Kártya jogosultság ellenőrzés",
      "dense": "",
      "filled": "",
      "hide-details": ""
    },
    model: {
      value: _vm.cardNumber,
      callback: function ($$v) {
        _vm.cardNumber = $$v;
      },
      expression: "cardNumber"
    }
  }), _c('v-btn', {
    staticClass: "ml-3 rounded-xl",
    attrs: {
      "color": "primary",
      "depressed": "",
      "fab": "",
      "small": ""
    },
    on: {
      "click": _vm.fetchCardInfo
    }
  }, [_c('v-icon', [_vm._v("mdi-magnify")])], 1)], 1), _vm.cardQueryLog ? _c('v-divider', {
    staticClass: "my-6"
  }) : _vm._e(), _vm.cardQueryLog ? _c('div', [_c('h2', {
    staticClass: "mb-3"
  }, [_vm._v("Kártya ellenőrzés eredménye:")]), _c('v-card', {
    staticClass: "mb-3 rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v(" Log ID: " + _vm._s(_vm.cardQueryLog.log_id) + " | " + _vm._s(_vm.cardQueryLog.found ? 'Kártya megtalálva' : 'Kártya nem található') + " ")]), _c('v-card-text', [_c('pre', {
    staticClass: "body-2",
    staticStyle: {
      "font-family": "monospace"
    }
  }, [_vm._v(_vm._s(_vm.cardQueryLog.result))])])], 1)], 1) : _vm._e()], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }